/* istanbul ignore file */
import React, { ReactElement } from "react";
import {
  Column,
  StyledTable,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "./BaseTable";
import { Paragraph } from "./Paragraph";
import { VinkjeIcon } from "./VinkjeIcon";
import { DashIcon } from "./DashIcon";

interface Props {
  columns: Column[];
  data: any[] | undefined;
  labelAccessor: string;
  valueAccessor: string;
  toelichting?: string | null;
}

const RadioTable: React.FC<Props> = ({
  columns,
  data,
  labelAccessor,
  valueAccessor,
  toelichting,
}: Props) => {
  const AddHeaderRows = (): ReactElement => {
    return (
      <tr>
        {columns.length > 0 &&
          columns.map((column, index) => (
            <TableHeaderCell
              key={`th_${index}`}
              align={column.align}
              style={index === 0 ? { width: "40%" } : undefined}
            >
              {column.header}
            </TableHeaderCell>
          ))}
      </tr>
    );
  };

  const GetRows = (): ReactElement => {
    if (!data) return <></>;

    return (
      <>
        {data.map((row, rowIndex) => (
          <TableRow key={rowIndex} index={rowIndex}>
            {columns.map((col, colIndex) => {
              const isFirstRow = rowIndex === 0;
              const isLastRow = data && rowIndex === data.length - 1;
              const isFirstCol = colIndex === 0;
              const isLastCol = colIndex === columns.length - 1;
              if (colIndex === 0) {
                return (
                  <TableCell
                    key={colIndex}
                    isFirstRow={isFirstRow}
                    isLastRow={isLastRow}
                    isFirstCol={isFirstCol}
                    isLastCol={isLastCol}
                    style={{ width: "35%" }}
                  >
                    {row[labelAccessor]}
                  </TableCell>
                );
              }
              return (
                <TableCell
                  key={colIndex}
                  align={col.align}
                  isFirstRow={isFirstRow}
                  isLastRow={isLastRow}
                  isFirstCol={isFirstCol}
                  isLastCol={isLastCol}
                >
                  {row[valueAccessor] === col.header ? <VinkjeIcon /> : <DashIcon />}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <div className="break-avoid">
      <StyledTable id="radio-table">
        <TableHeader>{AddHeaderRows()}</TableHeader>
        <tbody>{GetRows()}</tbody>
      </StyledTable>
      {toelichting && (
        <Paragraph>
          <i>Toelichting:</i>
          <br />
          {toelichting}
        </Paragraph>
      )}
    </div>
  );
};

export default RadioTable;
